import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { tap, pipe, takeUntil, Subject } from 'rxjs';

@Component({
  selector: 'header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderComponent implements OnInit {
  @Input() currentStep!: string;
  propertyAddress: any;
  @Input() isMobile: boolean = false;
  phoneEnd: string = '';
  email: string = '';
  isLogin: boolean = false;
  private _destroy$ = new Subject();
  isDirectLogin: boolean = false;
  rescheduling:boolean = false
  @Output() goToStep = new EventEmitter<any>()

  constructor(
    private translate: TranslateService,
    private router: Router,
    private cd: ChangeDetectorRef,
  ) {
  }

  ngOnInit() {
  }


  ngOnDestroy() {
    this._destroy$.next(null);
    this._destroy$.complete();
  }

  back() {
    this.router.navigate(['request','contact-info'])
  }

  toStep(step: string) {
    this.router.navigate(['request',step])
  }
}
